// Taining 8 oz Winder
import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt, CommonRows, InputRangeRow, ProgramRow, RunTimeRow } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";

export default function MachineTaining35AFP() {
   const { onChange, onChangeErrorDivDefinitions, handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };
   return (
      <>
         <ProgramRow hash />
         <InputRangeRow
            titleProp={"Yarn Length"}
            descriptionProp={"Clock Setting"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={99999}
            propertyNameProp={"clockSet"}
            errorDialogueProp={"0-99,999 only"}
            floatProp={false}
         />
         <RunTimeRow />
         <Row className="mb-2">
            <ColPrompt title={"Specification"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.specification || ""}
                  onChange={(e) => {
                     const { value } = e.target;
                     const regex = /^\d{3}d\d{1}$/;
                     if (regex.test(value)) {
                        onChange("extendedPropertyJson.specification", e.target.value);
                        if (errorDivDefinitions?.["specification"]) {
                           onChangeErrorDivDefinitions("specification", false);
                        }
                     } else {
                        onChange("extendedPropertyJson.specification", e.target.value);
                        onChangeErrorDivDefinitions("specification", true);
                     }
                  }}
               />
               {errorDivDefinitions.specification && (
                  <ErrorDiv>Must be formatted like XXXdX</ErrorDiv>
               )}
            </ColValue>
         </Row>
         <InputRangeRow
            titleProp={"Lube Roller Speed"}
            descriptionProp={"rpm"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0.0}
            maxProp={20.0}
            propertyNameProp={"speed"}
            errorDialogueProp={"0.0-20.0 only"}
            floatProp={true}
         />

         <Row className="mb-2">
            <ColPrompt title={"Yarn Tensioner"} bold={true} description={"%"} />
            <ColValue size={2}>
               {"High:"}
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson?.["tensionHigh"] || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 0, 100, "tensionHigh")
                        : handleInputRangeChange(defaultOnChangeVal, 0, 100, "tensionHigh")
                  }
               />
               {errorDivDefinitions?.["tensionHigh"] && (
                  <ErrorDiv>{"0-100 only"}</ErrorDiv>
               )}
            </ColValue>
            <ColValue size={2}>
               {"Low:"}
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson?.["tensionLow"] || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 0, 100, "tensionLow")
                        : handleInputRangeChange(defaultOnChangeVal, 0, 100, "tensionLow")
                  }
               />
               {errorDivDefinitions?.["tensionLow"] && (
                  <ErrorDiv>{"0-100 only"}</ErrorDiv>
               )}
            </ColValue>
            <ColValue size={2}>
               {"Mid:"}
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson?.["tensionMid"] || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 0, 100, "tensionMid")
                        : handleInputRangeChange(defaultOnChangeVal, 0, 100, "tensionMid")
                  }
               />
               {errorDivDefinitions?.["tensionMid"] && (
                  <ErrorDiv>{"0-100 only"}</ErrorDiv>
               )}
            </ColValue>
         </Row>
         <InputRangeRow
            titleProp={"Yarn Tensioner (LI)"}
            descriptionProp={"meters"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={99999}
            propertyNameProp={"tensionLI"}
            errorDialogueProp={"0-99,999 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Spacing"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={8500}
            propertyNameProp={"spacing"}
            errorDialogueProp={"0-8,500 only"}
            floatProp={false}
         />
         <CommonRows />
      </>
   );
}
